export const HiddenQuestionTypes = ['control_helper', 'control_hidden', 'control_autoincrement'];

export const BLOT_REGEX = /\{([a-z0-9]*?-[a-z0-9]*?)\}/gi;
export const TIMESTAMP_OF_2019 = 1546300000000;

export const paymentTypeWithShipping = [
  'control_paypal',
  'control_payment',
  'control_stripe',
  'control_stripeCheckout',
  'control_stripeACH',
  'control_stripeACHManual',
  'control_authnet',
  'control_bluepay',
  'control_bluesnap',
  'control_braintree',
  'control_chargify',
  'control_cardconnect',
  'control_echeck',
  'control_eway',
  'control_2co',
  'control_paypalpro',
  'control_paypalcomplete',
  'control_cybersource',
  'control_paymentwall',
  'control_paypalexpress',
  'control_worldpay',
  'control_dwolla',
  'control_square',
  'control_firstdata',
  'control_paypalInvoicing',
  'control_payjunction',
  'control_wepay',
  'control_worldpayus',
  'control_payu',
  'control_pagseguro',
  'control_moneris',
  'control_mollie',
  'control_sofort',
  'control_sensepass',
  'control_paysafe',
  'control_iyzico',
  'control_skrill',
  'control_gocardless',
  'control_paypalSPB',
  'control_payfast'
];

export const paymentTypeWithTax = [
  'control_payment',
  'control_paypal',
  'control_authnet',
  'control_echeck',
  'control_eway',
  'control_stripe',
  'control_stripeCheckout',
  'control_stripeACH',
  'control_stripeACHManual',
  'control_paypalpro',
  'control_paypalcomplete',
  'control_cybersource',
  'control_2co',
  'control_paypalexpress',
  'control_braintree',
  'control_dwolla',
  'control_square',
  'control_bluepay',
  'control_bluesnap',
  'control_firstdata',
  'control_paypalInvoicing',
  'control_payjunction',
  'control_paymentwall',
  'control_wepay',
  'control_worldpayus',
  'control_chargify',
  'control_cardconnect',
  'control_payu',
  'control_payuMoney',
  'control_pagseguro',
  'control_moneris',
  'control_mollie',
  'control_sofort',
  'control_sensepass',
  'control_skrill',
  'control_paysafe',
  'control_iyzico',
  'control_gocardless',
  'control_paypalSPB',
  'control_payfast'
];
